import React, { Component } from 'react';


class SearchContent extends Component{
    constructor(props){
        super(props);
        this.state = {
            filtered: 0,
            listing: [],
        }
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange = () => {
        this.setState({filtered: this.state.filtered + 1});
        var datas = this.props.listing;

        datas = datas.sort((a, b) => a.title.localeCompare(b.title));
        //datas = datas.sort((a, b) => new Date(a.created_at) + new Date(b.created_at));

        this.setState({listing: datas});
        console.log(datas);


    }

    render(){
        if(this.state.filtered == 0) {
            return (
                <div className="searchcontent">
                    <div className="container">
                        <div className="row odsunCont">
                            <div className="col-md-12">

                                <div className="result-sorting-wrapper">
                                    <div className="sorting-count">
                                        <p><span> {this.props.findSlug("naslo")} </span>{
                                            Array.isArray(this.props.listing) ? (
                                                this.props.listing.length
                                            ) : (
                                                0
                                            )
                                        }

                                        </p>
                                    </div>
                                    <div className="result-sorting-by">
                                        <p> {this.props.findSlug("zoradit")} </p>
                                        <form action="" method="get" id="ShortOrder" name="sortinglisting">
                                            <div className="form-group select sorting-select">
                                                <select id="order_list" className="form-control" name="listing_order"
                                                        onChange={this.handleChange}>
                                                    <option value="select "> Vyberte</option>
                                                    <option value="Asc"> A-Z</option>

                                                </select>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="ikonkax">

                                <a onClick={this.props.setSearch} className="backsearch"><i class="fas fa-search"></i></a><br/><br/>
                                </div>

                                <div className="row">

                                    {Array.isArray(this.props.listing) ? (
                                        this.props.listing.map(listing =>

                                            <div className="col-md-4">
                                                <a onClick={() => this.props.setDetail(listing.id)}>
                                                    <div className="box">
                                                        <div className="feat_img">
                                                            <a onClick={() => this.props.setDetail(listing.id)}>

                                                                <div className='obrlist' style={ {backgroundImage: "url(" + listing.featured_image + ")"} }></div>

                                                                {/*<img*/}
                                                                {/*className="img-responsive"*/}
                                                                {/*src={listing.featured_image}/>*/}


                                                            </a>
                                                        </div>
                                                        <div className="info">
                                                            {listing.categories.map(category =>
                                                                <div className="post_category">
                                                                    <a>{category.title}</a>
                                                                </div>
                                                            )

                                                            }
                                                            <h3 className="box_head">{listing.title}</h3>
                                                            <h6 className="box_subhead">{listing.subname}</h6>


                                                        </div>
                                                        <div className="box-inf">

                                                            <p className="listing_map_m fl">
                                                                <i className="fas fa-map-marker-alt"></i>
                                                                {listing.district.name}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        )) : (
                                        <div className="col-md-6">
                                            <div>
                                                <h3>{this.props.listing.message}</h3>
                                            </div>
                                        </div>
                                    )
                                    }


                                </div>

                            </div>


                        </div>
                    </div>
                </div>
            );
        }
        else{
            return (
                <div className="searchcontent">
                    <div className="container">
                        <div className="row odsunCont">
                            <div className="col-md-8">

                                <div className="result-sorting-wrapper">
                                    <div className="sorting-count">
                                        <p><span> {this.props.findSlug("naslo")} </span>{
                                            Array.isArray(this.props.listing) ? (
                                                this.state.listing.length
                                            ) : (
                                                0
                                            )
                                        }

                                        </p>
                                    </div>
                                    <div className="result-sorting-by">
                                        <p> {this.props.findSlug("zoradit")} </p>
                                        <form action="" method="get" id="ShortOrder" name="sortinglisting">
                                            <div className="form-group select sorting-select">
                                                <select id="order_list" className="form-control" name="listing_order"
                                                        onChange="document.form.submit();">
                                                    <option value="select">Vyberte</option>
                                                    <option value="Asc"> A-Z</option>

                                                </select>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <a onClick={this.props.setSearch} className="backsearch"><i class="fas fa-search"></i></a><br/><br/>

                                <div className="row">

                                    {Array.isArray(this.props.listing) ? (
                                        this.state.listing.map((listing,i) =>

                                            <div key={i} className="col-md-6">
                                                <a onClick={() => this.props.setDetail(listing.id)}>
                                                    <div className="box">
                                                        <div className="feat_img">
                                                            <a onClick={() => this.props.setDetail(listing.id)}>
                                                                <div className='obr' style={ {backgroundImage: "url(" + listing.featured_image + ")"} }></div>

                                                                {/*<img*/}
                                                                {/*className="img-responsive"*/}
                                                                {/*src={listing.featured_image}/>*/}

                                                            </a>
                                                        </div>
                                                        <div className="info">
                                                            {listing.categories.map(category =>
                                                                <div className="post_category">
                                                                    <a>{category.title}</a>
                                                                </div>
                                                            )

                                                            }
                                                            <h3 className="box_head">{listing.title}</h3>
                                                            <h6 className="box_subhead">{listing.subname}</h6>


                                                        </div>
                                                        <div className="box-inf">

                                                            <p className="listing_map_m fl">
                                                                <i className="fas fa-map-marker-alt"></i>
                                                                {listing.district.name}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        )) : (
                                        <div className="col-md-6">
                                            <div>
                                                <h3>{this.state.listing.message}</h3>
                                            </div>
                                        </div>
                                    )
                                    }


                                </div>

                            </div>
                            {/*<div className="col-md-4">*/}
                                {/*<div className="newsearch">*/}
                                    {/*<div className="nicstenenasli">*/}
                                        {/*<i className="fa fa-search inl" aria-hidden="true"></i>*/}
                                        {/*<h6>{this.props.findSlug("nic")}</h6>*/}
                                    {/*</div>*/}
                                    {/*<div className="nicwrap">*/}
                                        {/*<a className="button"*/}
                                           {/*onClick={this.props.setSearch}>{this.props.findSlug("hladat")}</a>*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                            {/*</div>*/}

                        </div>
                    </div>
                </div>
            );
        }
    }
}
export default SearchContent;